import { useQuery } from 'react-query';
import { getLicensesData } from './queries';

export const useLicensesData = () => {
  return useQuery('licenses-data', getLicensesData);
};
